import { createContext, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import {
  createStreamManagerStore,
  StreamManagerState,
} from "src/reusable/Chat/ChatStreaming/stores/StreamManagerStore";
import { StoreApi } from "zustand";

// Preserve context across Vite HMR using import.meta.hot.data
// Module-level variables reset on re-evaluation; import.meta.hot.data persists
const getOrCreateContext = () => {
  if (import.meta.hot?.data?.chatStreamingContext) {
    return import.meta.hot.data
      .chatStreamingContext as React.Context<StoreApi<StreamManagerState> | null>;
  }
  const ctx = createContext<StoreApi<StreamManagerState> | null>(null);
  if (import.meta.hot?.data) {
    import.meta.hot.data.chatStreamingContext = ctx;
  }
  return ctx;
};

export const ChatStreamingContext = getOrCreateContext();

if (import.meta.hot) {
  import.meta.hot.accept();
}

export const ChatStreamingProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const [store] = useState(createStreamManagerStore);
  const queryClient = useQueryClient();

  useEffect(() => {
    store.getState().setQueryClient(queryClient);
  }, [store, queryClient]);

  return (
    <ChatStreamingContext.Provider value={store}>
      {children}
    </ChatStreamingContext.Provider>
  );
};
